import * as React from "react";

interface IProps {
    buttonId: string;
    disabled: boolean;
    wrapperClass?: string;
    onClick: (event: any) => void;
}

export class NextButton extends React.Component<IProps, {}> {
    constructor(props: IProps) {
        super(props);
    }

    public render() {
        return (
            <div className={`px-4 px-md-0 ml-md-19 padding-left-right-0-mb ${this.props.wrapperClass || ""}`}>
                <button type="button" className="btn btn-primary btn-next plugin"
                        id={this.props.buttonId}
                        disabled={this.props.disabled}
                        onClick={this.handleClick}>Next</button>
            </div>
        )
    }

    private handleClick = (event: any): void => {
        event.target.disabled ? event.preventDefault() : this.props.onClick(event);
    };
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/subscription/motor/motorClaims/NextButton.tsx